var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { AppIcon } from './AppIcon';
import { COLOR_TOKENS } from '../colors/colors';
import { SHADOWS } from '../shadows/shadows';
import { RADIUS } from '../spacing/spacing';
export var FEATURED_ICON_SIZES = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
};
var APP_ICON_SIZES = {
    sm: '16px',
    md: '20px',
    lg: '24px',
    xl: '28px',
};
var COMMON_STYLES = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    background: COLOR_TOKENS['Colors/Background/bg-primary'],
};
var BORDER_STYLES = {
    border: "1px solid ".concat(COLOR_TOKENS['Gray/200']),
    boxShadow: "".concat(SHADOWS['shadow-skeumorphic-inner-border'], ", ").concat(SHADOWS['shadow-skeumorphic-inner'], ", ").concat(SHADOWS['shadow-xs']),
};
var CONTAINER_SX = {
    sm: __assign({ width: '32px', height: '32px', padding: '8px', borderRadius: RADIUS['radius-sm'] }, COMMON_STYLES),
    md: __assign({ width: '40px', height: '40px', padding: '10px', borderRadius: RADIUS['radius-md'] }, COMMON_STYLES),
    lg: __assign({ width: '48px', height: '48px', padding: '12px', borderRadius: RADIUS['radius-lg'] }, COMMON_STYLES),
    xl: __assign({ width: '56px', height: '56px', padding: '14px', borderRadius: RADIUS['radius-xl'] }, COMMON_STYLES),
};
export var FeaturedIcon = function (_a) {
    var iconName = _a.iconName, size = _a.size, _b = _a.shape, shape = _b === void 0 ? 'square' : _b, color = _a.color, fill = _a.fill, strokeWidth = _a.strokeWidth, backgroundColor = _a.backgroundColor, _c = _a.border, border = _c === void 0 ? true : _c, borderColor = _a.borderColor;
    var SX = __assign(__assign(__assign({}, CONTAINER_SX[size]), (border ? BORDER_STYLES : {})), { borderRadius: shape === 'round' ? RADIUS['radius-full'] : CONTAINER_SX[size].borderRadius, backgroundColor: backgroundColor ? COLOR_TOKENS[backgroundColor] : undefined, borderColor: borderColor ? COLOR_TOKENS[borderColor] : undefined });
    return (_jsx(Box, { sx: SX, children: _jsx(AppIcon, { color: color, fill: fill, strokeWidth: strokeWidth, iconName: iconName, diameter: APP_ICON_SIZES[size] }) }));
};
